import React, { Component } from 'react'

import ContentInfo from '../_ContentInfo'
import Display from '../../../../../v2SPRINTA/atoms/Display'
import { FormGroup, Text } from '../../../../../v2SPRINTA/atoms/Form'
import { Col, Row } from '../../../../../v2SPRINTA/atoms/Grid'

import { numberFormat, toDecimal } from '../../../../../SPRINTA/helpers/Formatter'

import { saveExperience } from '../../_utils'


class Price extends Component {
    inputRefs = {}

    handleChange(target) {
        let experience = this.props.data.experience
        experience[target.name] = target.value
        
        this.props.setData({
            experience
        }, () => {
            if(['radio', 'select-one', 'checkbox'].indexOf(target.type) > -1)
            this.handleChanged(target)
        })
    }
    
    handleChanged(target) {
        this.validAndSaveField(target)
    }

    validAndSaveField(target) {
        const { name } = target

        if(this.hasFieldError[name] && this.hasFieldError[name]()) return;

        const form = {}
        form[name] = toDecimal(this.props.data.experience[name])*100

        let async = saveExperience(this.props.token, form)
        .then(resp => {})

        if(this.props.async) this.props.async(async)
    }

    hasFieldError = {
        price: () => {
            if(!this.props.data.experience.price) {
                let error = 'Campo obrigatório'
                this.refs['price'].setError(error)
                return {
                    element: this.refs['price'].refs.input,
                    error
                }
            }

            return false
        }
    }


    validate() {
        let errors = []

        Object.keys(this.hasFieldError).forEach(item => {
            let error = this.hasFieldError[item]();
            if(error)
            errors.push(error)
        })

        return errors
    }

    inStep() {
        let { price } = this.props.data.experience
        return price ? true  : false
    }

    render() {
        return (
            <ContentInfo
                title='Qual o valor da sua diária?'
                description='Coloque o valor que você gostaria que os visitantes pagassem por acesso na sua academia. Depois que ela for aprovada, você poderá alterar os valores sempre que quiser.'
                steps={this.props.steps}>

                <Row>
                    <Col size='12'>
                        <FormGroup>
                            <Display size={3}>
                                Valor do acesso diário
                            </Display>
                        </FormGroup>
                    </Col>

                    <Col size='8 8 6'>
                        <FormGroup>
                            <Text
                                label='Qual o preço?'
                                name="price"
                                ref='price'
                                defaultValue={this.props.data.experience.price ? numberFormat(this.props.data.experience.price/100, 2, ',', '.') : ''}
                                mask={'money_br'}
                                onChangeDOM={e => this.handleChanged(e.target)}
                                onChange={e => this.handleChange(e.target)}
                                />
                        </FormGroup>
                    </Col>
                </Row>

            </ContentInfo>
        )
    }

}

export default Price


// WEBPACK FOOTER //
// ./src/App/pages/CreateGym/Steps/Price/index.js